$('main.inscription-commune .referent-plus').on('click', function () {

    let input = '<hr>' +
        '<div class="form-split d-flex justify-content-between">' +
        '<div class="input-wrapper mx-2">' +
        '<input type="text" name="first_name[]" class="custom-input" placeholder="Prénom du référent">' +
        '</div>' +
        '<div class="input-wrapper mx-2">' +
        '<input type="text" name="last_name[]" class="custom-input" placeholder="Nom du référent">' +
        '</div>' +
        '<div class="input-wrapper mx-2">' +
        '<input type="text" name="email_ref[]" class="custom-input" placeholder="Email du référent">' +
        '</div>' +
        '</div>' +
        '<div class="form-split d-flex justify-content-between">' +
        '<div class="input-wrapper mx-2">' +
        '<input type="text" name="fonction_ref[]" class="custom-input" placeholder="Fonction du référent">' +
        '</div>' +
        '<div class="input-wrapper mx-2">' +
        '<input type="text" name="land_phone_ref[]" class="custom-input" placeholder="Tél. fixe du référent">' +
        '</div>' +
        '<div class="input-wrapper mx-2">' +
        '<input type="text" name="mobile_phone_ref[]" class="custom-input" placeholder="Tél. mobile du référent">' +
        '</div>' +
        '</div>';

    $('#referent-input-wrap').append(input);
})


// WEBPACK FOOTER //
// ./src/js/app/inscription-commune.js